export const QR_CODE_SCALE = 11;
export const QR_CODE_TEST_ID = 'redemption-qr-code';
export const QR_CODE_SELECTOR = `[data-testid="${QR_CODE_TEST_ID}"]`;
